import { UserType } from '@/generated/graphql';

export const MAX_AVATARS_SHOWN_WITHOUT_HIDING = 5;

export const FILTERED_USER_TYPES = [
	UserType.User,
	UserType.Cupo,
	UserType.Admin,
];

export const UserAssignSelectSize = {
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
} as const;

export const UserAssignSelectFooterVariant = {
	DEFAULT: 'default',
	INLINE: 'inline',
} as const;
